import { render, staticRenderFns } from "./vs-form-switch.vue?vue&type=template&id=b19d5c4c&scoped=true"
import script from "./vs-form-switch.vue?vue&type=script&lang=js"
export * from "./vs-form-switch.vue?vue&type=script&lang=js"
import style0 from "./vs-form-switch.vue?vue&type=style&index=0&id=b19d5c4c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b19d5c4c",
  null
  
)

export default component.exports